import requests from "./httpService";

const CottageServices = {

    getCottage : async () =>{
        return requests.get(`/cottage`);
    },
    createCottage : async (body) =>{
        return requests.post(`/cottage`,body);
    },
    updateCottage : async (id,body) =>{
        return requests.patch(`/cottage/${id}`,body);
    },
   
   
    deleteCottage : async (id) =>{
        return requests.delete(`/cottage/${id}`);
    },
    uploadImage : async (body) =>{
        return requests.post(`/cottage/uploadImage`,body);
    },
    uploadPropertyImage : async (body) =>{
        console.log(body)
        return requests.post(`/cottage/upload/PropertyImage`,body);
    },
    removeImage : async (body) =>{
        return requests.post(`/cottage/removeImage`,body);
    }
  


}

export default CottageServices;